import "./HowItWorks.css";
import { FaPhone } from "react-icons/fa6";
import leafLeft from "../images/work1.webp";   // <-- your left leaf image
import leafRight from "../images/work2.webp"; // <-- your right leaf image
  import Aos from "aos";
  import "aos/dist/aos.css";
  import { useEffect } from "react";
  
export default function HowItWorks() {

    useEffect(() => {
    Aos.init({
      duration: 1000,      // animation duration
      easing: "ease-in-out",
      once: true,          // animation happens only once
      offset: 100,         // offset from the trigger point
    });
  
    Aos.refresh(); // optional but recommended
  }, []);
  return (
    <section className="container-fluid hiw-section py-5" >

      {/* LEFT SIDE 3D LEAF */}
      <img src={leafLeft} alt="leaf" className="hiw-leaf hiw-leaf-left" />

      {/* RIGHT SIDE 3D LEAF */}
      <img src={leafRight} alt="leaf" className="hiw-leaf hiw-leaf-right" />

      <div className="container pb-5" data-aos="zoom-in">
        <div className="row align-items-center">

          {/* LEFT STEPS */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="hiw-step active">
              <div className="hiw-step-numberr">1</div>
              <div className="hiw-step-content">
                <h6 className="para-font">Consultation with Our Expert</h6>
                <p className="para-font">
                  Begin your wellness journey with a detailed consultation by our experienced Ayurvedic doctors.
                </p>
              </div>
            </div>

            <div className="hiw-step active">
              <div className="hiw-step-numberr">2</div>
              <div className="hiw-step-content">
                <h6 className="para-font">Get an appointment</h6>
                <p className="para-font">
                  Schedule your therapy sessions at a time that suits your routine and comfort.
                </p>
              </div>
            </div>

            <div className="hiw-step active">
              <div className="hiw-step-numberr">3</div>
              <div className="hiw-step-content">
                <h6 className="para-font">Enjoy your service</h6>
                <p className="para-font">
                  Relax and rejuvenate as our trained therapists deliver authentic Ayurvedic treatments.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6">
            <p className="hiw-label">HOW IT WORKS</p>
            <h2 className="hiw-title head-font">
              Treat your body with the care of nature
            </h2>

            <p className="hiw-text para-font justify-text">
              Experience authentic Ayurvedic healing designed to restore balance, vitality, and inner harmony. Our therapies follow nature’s rhythm, combining time-tested wisdom with mindful care for lasting wellness.

From your first consultation to your final therapy session, every step is personalized to your body’s needs—supporting deep relaxation, natural detoxification, and holistic healing.
            </p>
            <p className="hiw-text para-font justify-text">At Ayur Moksha, every therapy begins with understanding your unique body constitution and wellness goals. Our experienced Ayurvedic physicians and therapists carefully design personalized treatments that work in harmony with nature, helping your body heal gently yet deeply from within.</p>

            <div className="hiw-actions" style={{alignItems:'center',justifyContent:'center'}}>
              <div className="hiw-action-card">
              
                <div>
                  <h6 className="text-center"><b>&nbsp;Call Us Now!</b></h6>
                  <p className="text-center"><FaPhone className="text-success"/><b>&nbsp;+91 7736 111 482</b></p>
                </div>
              </div>
                <div className="hiw-action-card">
              
                <div>
                  <h6 className="text-center"><b>&nbsp;Online Consultation!</b></h6>
                  <p className="text-center"><b>Available</b></p>
                </div>
              </div>
             
            </div>

          </div>

        </div>
      </div><br/>
    </section>
  );
}
